import { Inject, Injectable } from "@angular/core";
import saveAs from 'file-saver';
import { LoadingController, Platform } from "ionic-angular";
import { FileDownloaderProvider } from "../../providers/file-downloader/file-downloader";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { LoopBackAuth } from "../../shared/sdk";
import { TimesheetReportDto, RequestTimesheetRecordEmailDto } from "../../shared/nestjs/gd-only/dto/timesheet-report.dto";
import { TimesheetReportApi } from "../../shared/nestjs/gd-only/services/timesheet-report.api";
import { AnalyticsProvider } from "../../providers/analytics/analytics";
import { EventNameAnalytics } from "../../helpers/event-name-analytics";

@Injectable()
export class TimesheetReportBloc {
  isGoPathNew: Boolean;
  loading: any;
  requestBody: TimesheetReportDto = new TimesheetReportDto();

  constructor(
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    private nestApiProvider: NestApiProvider,
    private platform: Platform,
    private fileDownloaderProvider: FileDownloaderProvider,
    private loadingCtrl: LoadingController,
    private timesheetReportApi: TimesheetReportApi,
    private analyticsProvider: AnalyticsProvider,
  ) {
  }


  async downloadExcel(dataRequest: TimesheetReportDto) {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    if (this.isGoPathNew) {
      this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
      return await this.generateExcel(dataRequest)
    }

  }

  generateExcel(data: TimesheetReportDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let downloadExcel = this.timesheetReportApi.downloadExcel(data).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadExcelBlob(result, 'Timesheet Report')
          resolve('Download successfully');
        } else {
          saveAs(result, 'Timesheet Report.xlsx')
          resolve('Download successfully');
        }
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
        this.loading.dismiss();
      });
    });
  }


  async downloadPDF(dataRequest: TimesheetReportDto) {
    this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    if (this.isGoPathNew) {
      this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
      return await this.generatePdf(dataRequest)
    }
  }

  private generatePdf(data: TimesheetReportDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let downloadExcel = this.timesheetReportApi.downloadPdf(data).subscribe(result => {
        if (this.platform.is('cordova')) {
          this.fileDownloaderProvider.downloadPdfBlob(result, 'Timesheet Report')
          resolve('Download successfully');
        } else {
          saveAs(result, 'Timesheet Report.pdf')
          resolve('Download successfully');
        }
      }, error => {
        reject(error.message)
      }, () => {
        downloadExcel.unsubscribe()
        this.loading.dismiss();
      })

    })
  }

  async sendMailExcel(data: RequestTimesheetRecordEmailDto) {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
    return await this.sendEmailExcel(data)

    // this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    // if (this.isGoPathNew) {
    //   this.requestSendEmail.code = data.periodId;
    //   this.requestSendEmail.emailTo = data.email;
    //   this.requestSendEmail.fullName = data.fullName;
    //   return await this.sendEmailExcel(data)
    // } else {
    //   return await this.sendEmailExcelLB(data);
    // }
  }

  async sendMailPdf(data: RequestTimesheetRecordEmailDto) {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
    return await this.sendEmailPdf(data)
    // this.isGoPathNew = await this.nestApiProvider.isGoPathNewExist();
    // if (this.isGoPathNew) {
    //   this.requestSendEmail.code = data.code;
    //   this.requestSendEmail.emailTo = data.emailTo;
    //   this.requestSendEmail.fullName = data.fullName;
    //   return await this.sendEmailPdf(data)
    // } else {
    //   return await this.sendEmailPdfLB(data);
    // }
  }

  private async sendEmailPdf(data: RequestTimesheetRecordEmailDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let sendEmailPdf = this.timesheetReportApi.reportSendEmailPdf(data).subscribe(result => {
        resolve("Send Email Successfully")
      }, error => {
        reject(error.message);
        console.log('error', error);
      }, () => {
        sendEmailPdf.unsubscribe();
      })
    })
  }

  private async sendEmailExcel(data: RequestTimesheetRecordEmailDto): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.loader();
      let sendEmailExcel = this.timesheetReportApi.reportSendEmailExcel(data).subscribe(result => {
        resolve("Send Email Successfully");
      }, error => {
        reject(error.message);
      }, () => {
        this.loading.dismiss();
        sendEmailExcel.unsubscribe();
      })
    })
  }


  loader(): void {
    this.loading = this.loadingCtrl.create();
    this.loading.present();
  }

}



// WEBPACK FOOTER //
// ./src/bloc/report/timesheet-report.bloc.ts